import { error } from 'laravel-mix/src/Log'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

// Primary color depende sa environment (galing window.appEnv = config('app.env')).
// Runtime ang basehan kaya iisang build lang, iba-iba ang kulay per server.
const PRIMARY_BY_ENV = {
    local: '#6e7881', // local: secondary
    dev: '#795548', // dev: brown
    development: '#795548',
    staging: '#795548'
}
const env = (window.appEnv || '').toLowerCase()
const primary = PRIMARY_BY_ENV[env] || '#7c31a1' // prod / default: primary

const opts = {
    theme: {
        // Restore the user's saved night-mode choice (per device). Key must match
        // DARK_MODE_KEY in resources/js/mixins/darkMode.js.
        dark: (() => { try { return localStorage.getItem('rcms_dark_mode') === '1'; } catch (e) { return false; } })(),
        themes: {
            light: {
                primary,
                secondary: '#6e7881'
                //error: '#E65100',
            },
            dark: {
                primary,
                secondary: '#6e7881'
                //error: '#E65100',
            }
        }
    }
}

export default new Vuetify(opts)
